/*
 * LA RESTA COMPLETA, CON LOS CUATRO RENGLONES A LA VISTA (RN-228, RF-102, D-146).
 *
 *   TOTAL PRESUPUESTO          totalPresupuestado
 *   − TOTAL GASTADO            totalGastado              (categorías CON presupuesto)
 *   − GASTADO SIN PRESUPUESTO  totalGastoSinPresupuesto  (categorías SIN presupuesto)
 *   = TOTAL DISPONIBLE         totalDisponible           (puede ser negativo)
 *
 * ESTA PANTALLA NO SUMA NI RESTA (RNF-053): recibe los TRES TÉRMINOS y el
 * disponible YA RESUELTOS por el servidor y los muestra. Los dos conjuntos de
 * categorías son disjuntos, así que no hay doble conteo; fundir el tercer renglón
 * dentro del segundo escondería cuánto se fue por fuera del plan (RN-228e).
 *
 * EL DISPONIBLE NEGATIVO SE MUESTRA CON SU SIGNO Y NO SE RECORTA A CERO (RN-228d).
 */

import { esNegativo, importe } from '../formato.js';

function Renglon({ operador, etiqueta, detalle, valor, marca, destacado = false }) {
  const negativo = esNegativo(valor);

  return (
    <div className="fila" data-prueba={marca}>
      <span aria-hidden="true" style={{ width: 14, fontWeight: 900 }}>{operador}</span>
      <span className="crece">
        {destacado ? <b>{etiqueta}</b> : etiqueta}
        {detalle && <small style={{ display: 'block' }}>{detalle}</small>}
      </span>
      <span
        className={`imp${negativo ? ' g' : ''}`}
        data-prueba={`${marca}-valor`}
        style={destacado ? { fontSize: '1.15em', fontWeight: 900 } : undefined}
      >
        {importe(valor)}
      </span>
    </div>
  );
}

export function ResumenDeCuatroRenglones({ tablero }) {
  const disponibleNegativo = esNegativo(tablero.totalDisponible);

  return (
    <div className="card" style={{ margin: 12 }} data-prueba="resumen-de-la-resta">
      <Renglon
        operador=""
        etiqueta="Total presupuesto"
        valor={tablero.totalPresupuestado}
        marca="resumen-presupuestado"
      />
      <Renglon
        operador="−"
        etiqueta="Total gastado"
        detalle="categorías con presupuesto"
        valor={tablero.totalGastado}
        marca="resumen-gastado"
      />
      <Renglon
        operador="−"
        etiqueta="Gastado sin presupuesto"
        detalle="categorías sin presupuesto · el detalle está en su propio bloque"
        valor={tablero.totalGastoSinPresupuesto}
        marca="resumen-gasto-sin-presupuesto"
      />
      <Renglon
        operador="="
        etiqueta={tablero.esPeriodoFuturo ? 'Total disponible (proyectado)' : 'Total disponible'}
        valor={tablero.totalDisponible}
        marca="resumen-disponible"
        destacado
      />

      {disponibleNegativo && (
        <div className="aviso e" role="status" data-prueba="explicacion-disponible-negativo">
          <b>Disponible negativo.</b> Se muestra con su signo y <b>no se recorta a cero</b>:
          gastaste más de lo que planeaste para este mes, contando también lo que gastaste
          fuera del plan.
        </div>
      )}

      {/* Lo resuelve el SERVIDOR (D-147): sin este dato el tablero podría decir
          "dentro del presupuesto" y un disponible negativo sin explicar por qué. */}
      {tablero.elDisponibleEsNegativoPorGastoSinPresupuesto && (
        <div className="aviso w" role="status" data-prueba="explicacion-por-gasto-sin-presupuesto">
          <b>Tu gasto sin presupuesto es lo que deja el disponible en negativo.</b> Con lo
          presupuestado y lo gastado de las categorías que sí tienen cifra todavía te quedaría
          saldo. Por eso el estado global puede decir «dentro del presupuesto» y el disponible
          salir en rojo: son dos cosas distintas y las dos son ciertas.
        </div>
      )}

      <span className="ayuda">
        El gasto sin presupuesto va en su <b>propio renglón</b> y no dentro del gastado: los dos
        conjuntos de categorías no se solapan, así que restarlos por separado da el mismo
        resultado <b>sin contar nada dos veces</b>. El avance y el estado globales se calculan
        solo con los dos primeros renglones.
      </span>
    </div>
  );
}
